import React, { useState, useEffect } from "react";
import "./planpagelayout.css";
import { useDispatch, useSelector } from "react-redux";
import { QuickQuoteHealth,PostQuoteHealth,ErrQuotesHealth } from "../../Redux/actions/NumHealth";
import { 
  Button, 
  Form,
  Radio,
  message
} from 'antd/lib';
import axiosInHealth from "../../Redux/axios/AxiosInHealth";
export default function MultiYearHeath({setisModalMultiYr}) {
    const dispatch = useDispatch();
    const Healthnum = useSelector((state) => state?.healthdetail?.healthnum);
  const QuotePost = useSelector((state) => state?.healthdetail?.QuickQuotePost);
    const QuickQuotes = useSelector((state) => state?.healthdetail?.quickquotes);
    const QuickQuotePost = useSelector((state) => state?.healthdetail?.quickQuotePost);
    const QuoteInput = useSelector((state) => state?.healthdetail?.quoteInput);
    const [loading, setLoading] = useState(false)

    const onChange = (e) => {
      console.log('radio checked', e.target.value);
      // setValue(e.target.value);
    };
    const onFinish = (values) => {
      console.log('product values',values)
      const UpdatePlan = {
        ...QuotePost,
        policyPeriod : values?.multiYear,
      }
      setLoading(true)
      axiosInHealth
      .post(`v1/health_insurances/${Healthnum?.health_insurance_id}/quick_quotes`, UpdatePlan)
        .then((res) => {
          if (res.status === 200) {
            const data = res?.data?.data
          console.log(data)
            const errData = data?.filter(item => ("status" in item && item.status === "failed"));
            dispatch(ErrQuotesHealth(errData));
            const filteredData = data?.filter(item => ("status" in item && item.status === "success"));
            const updatedData = filteredData?.map(item => ({
              ...item,
              selected: false
            }));
            dispatch(QuickQuoteHealth(updatedData));
            dispatch(PostQuoteHealth(UpdatePlan))
            setLoading(false)
            setisModalMultiYr(false)
          }
        })
        .catch((err) => {
          console.log(err.response.data.error);
          setLoading(false)
          message.error(err.response.data.error);
        });
    }; 
  return (
    <>
       <Form
        onFinish={onFinish}
        layout="vertical"
        requiredMark={false}
        >
            <p className="border-bottom mb-0"
             style={{fontSize: "14px", paddingBottom:"10px"}}>Select desired policy period.</p>
          <Form.Item
          name="multiYear"
        // className="cvEditSec"
          rules={[
            {
              required: true,
              message: 'Please select Policy Type',
            },
          ]}
          initialValue={QuotePost?.policyPeriod}
          >
            <Radio.Group
              className="py-3 px-3 pb-0 bg-white ant-radio-layout prev-prod-sec-health"
              onChange={onChange}
              >
                <Radio value={1}>1 Year</Radio>
                <Radio value={2}>2 Years</Radio>
                <Radio value={3}>3 Years</Radio>
              </Radio.Group>
            </Form.Item>
            <Form.Item style={{textAlign: "center"}}>
                <Button type="primary" 
                htmlType="submit"
                className="update-qut-button"
                loading={loading}
                >Update</Button>
            </Form.Item>
        </Form>
    </>
  );
}
